import React from 'react';
import NavbarHeader from '../../../Styleguide/NavbarHeader/NavbarHeader';

const NonMobileNavBar = () => <NavbarHeader content='nav' />


export default NonMobileNavBar;
